import React from 'react';

const NewBuildingDeviceForm = ({
  deviceForm,
  handleDeviceFormChange,
  onSave,
  onCancel,
}) => {
  return (
    <div className="p-4 bg-gray-100 rounded-md mt-4 mb-12 border borer-gray-200">
      <h3 className="text-lg font-bold mb-4">New Device</h3>
      <form className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Device Type
          </label>
          <input
            type="text"
            name="deviceType"
            value={deviceForm.deviceType}
            onChange={handleDeviceFormChange}
            className="w-full border rounded-md p-2"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Device Status
          </label>
          <input
            type="text"
            name="deviceStatus"
            value={deviceForm.deviceStatus}
            onChange={handleDeviceFormChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Device Domain
          </label>
          <input
            type="text"
            name="deviceDomain"
            value={deviceForm.deviceDomain}
            onChange={handleDeviceFormChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Block
          </label>
          <input
            type="text"
            name="block"
            value={deviceForm.block}
            onChange={handleDeviceFormChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bin
          </label>
          <input
            type="text"
            name="bin"
            value={deviceForm.bin}
            onChange={handleDeviceFormChange}
            className="w-full border rounded-md p-2"
          />
        </div>

        {/* Add more fields if necessary */}

        <div className="flex justify-end space-x-2 mt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="px-4 py-2 border rounded-md bg-blue-500 text-white hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewBuildingDeviceForm;
